export const disableFilter = filter => ({
  ...filter,
  selected: false
})

export const toggleFilter = ({ selected, ...filter }) => ({
  ...filter,
  selected: !selected
})

const isEqualFilter = (firstFilter, secondFilter) =>
  firstFilter.navigationState === secondFilter.navigationState

export const updateFilter = (filters, selectedFilter, filterUpdater) => {
  const { groupIndex } = selectedFilter

  return filters.map((filterGroup, filterGroupIndex) =>
    filterGroupIndex !== groupIndex ?
      filterGroup :
      ({
        ...filterGroup,
        refinements: filterGroup.refinements.map(filter => isEqualFilter(filter, selectedFilter) ?
          filterUpdater(filter) :
          filter
        )
      })
  )
}

export const removeSelectedFilter = (selectedFilters, selectedFilter) =>
  selectedFilters.filter(filter => !isEqualFilter(filter, selectedFilter))
